import { Box, Flex, Text } from "@chakra-ui/react";
import TextMessagesIcon from "assets/img/support/text-messages.svg";

type Props = {
  title: string;
};

export default function ChatPlaceholder({ title }: Props) {
  return (
    <Flex align="center" justify="center" minH="520px">
      <Box textAlign="center" maxW="340px">
        <Box
          w="52px"
          h="52px"
          mx="auto"
          mb="16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="#0B0E10"
        >
          <Box as="img" src={TextMessagesIcon} alt="Messages" w="40px" h="40px" />
        </Box>
        <Text fontSize="16px" fontWeight="600" color="#0B0E10" mb="4px">
          {title}
        </Text>
      </Box>
    </Flex>
  );
}
